module.exports = __webpack_public_path__ + "img/gal_no.77874273.png";